import {
  CSVProductOperation,
  useMassivUpload,
} from '@/hooks/product/useMassiveUpload';
import { useImmer } from 'use-immer';
import { UploadCSVDialogUi } from './UploadCSVDialogUi';

const FILE_SANITIZED_NAME_MAX_LENGTH = 50;

export function useUploadCSVDialogController(
  popupType: CSVProductOperation | undefined,
  closeAction: () => void
) {
  const [uiState, setUiState] = useImmer<UploadCSVDialogUi>({});

  const massiveUploadHook = useMassivUpload();

  const onFileUploaded = (file: File | undefined) =>
    setUiState((draft) => {
      draft.fileUploaded = file;
      draft.uploadHelperText = file
        ? getFileUploadedSanitizedName(file)
        : undefined;
      draft.continueEnabled = !!file;
    });

  const onClickedUploadCsv = () => {
    if (!uiState.fileUploaded || !popupType) return;
    setUiState((draft) => {
      draft.isLoading = true;
    });
    massiveUploadHook.uploadCsv(
      {
        file: uiState.fileUploaded,
        operation: popupType,
      },
      {
        onSuccess: () => handleClose(),
        onSettled: () =>
          setUiState((draft) => {
            draft.isLoading = false;
          }),
      }
    );
  };

  const handleClose = () => {
    setUiState({});
    closeAction();
  };

  const getFileUploadedSanitizedName = (file: File) =>
    file.name.length > FILE_SANITIZED_NAME_MAX_LENGTH
      ? `${file.name.substring(0, 50)}...`
      : file.name;

  const getPopupTitle = () => {
    if (popupType === CSVProductOperation.UPDATE) return 'Actualizar Productos';
    if (popupType === CSVProductOperation.UPLOAD) return 'Cargar Productos';
  };

  return {
    uiState: {
      ...uiState,
      title: getPopupTitle(),
    },
    actions: {
      onFileUploaded,
      onClickedUploadCsv,
      handleClose,
    },
  };
}
